import { accountPlanQuery } from '../account-plan.toolkit-api';

type UseRequestPaidPlanResponseType = [
  (accountId: string) => void,
  AppSelectorType<void, string>
];

export const usePaidPlanRequestMutation = (): UseRequestPaidPlanResponseType => {
  const [
    requestPaidPlan,
    {
      data, isLoading, isError, error, isSuccess, reset,
    }] = accountPlanQuery.useRequestPaidPlanMutation();

  const meta = {
    isLoading, isError, error: error as string, isSuccess, data, resetState: reset,
  };

  return [
    requestPaidPlan,
    { ...meta },
  ];
};
